import { render, staticRenderFns } from "./BaseTostSuccess.vue?vue&type=template&id=036591eb&"
import script from "./BaseTostSuccess.vue?vue&type=script&lang=js&"
export * from "./BaseTostSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports